<template>
  <DesktopLayout>
    <Bubbles
      v-if="bubblesVisualisationActive"
    />
    <Sunburst
      v-if="sunburstVisualisationActive"
    />
    <CustomVisualisation
      v-if="customVisualisationActive"
    />
  </DesktopLayout>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import DesktopLayout from '@/components/public/DesktopLayout/DesktopLayout.vue'
import Bubbles from '@/components/public/Bubbles/Bubbles.vue'
import Sunburst from '@/components/public/Sunburst.vue'
import CustomVisualisation from '@/components/public/CustomVisualisation.vue'

const components = {
  DesktopLayout,
  Bubbles,
  Sunburst,
  CustomVisualisation,
}

@Component({ components })
export default class ProjectsView extends Vue {
  get bubblesVisualisationActive () {
    return this.$typedStore.activeVisualisation.isBubbles
  }

  get sunburstVisualisationActive () {
    return this.$typedStore.activeVisualisation.isSunburst
  }

  get customVisualisationActive () {
    return this.$typedStore.activeVisualisation.isCustom
  }
}

</script>
